import React from 'react';
import styled from '@emotion/styled';
import { Chip, ChipsList } from '@naf-simba/elements-chips';
import { useNavigate } from 'react-router-dom';
import useSelector from '../../redux/typedHooks';
import { SiteStructureType } from '../../../../types/siteStructureType';

interface Props {
  chips: string[];
  currentCategory?: SiteStructureType;
}

const SubCategoryChips = ({ chips, currentCategory }: Props) => {
  const categoriesState = useSelector((state) => state.sitestructure);
  const navigate = useNavigate();

  if (!categoriesState) return null;

  return (
    <ChipsWrapper>
      <ChipsList>
        {chips.map((chip: string) => {
          const chipCategory = categoriesState?.mappedCategories && categoriesState?.mappedCategories[chip]?.data;
          if (!chipCategory) return null;

          let chipUrl = chipCategory.url;
          let chipName = chipCategory.name;

          // If the chip is a global tag, use current category parent (if it is a subcategory), or currentcategory itself as url, to get correct filter (ie elbil/nyheter)
          // If the chip matches the current category then use category url
          if (chipCategory.isGlobalTag && currentCategory?.url !== chipCategory.url) {
            chipUrl = currentCategory?.parent
              ? `/${currentCategory.parentSlug}/${chipCategory.slug}`
              : `/${currentCategory?.slug}/${chipCategory.slug}`;
            chipName = chipCategory.name;
          }

          const selected = currentCategory && chipCategory && currentCategory.slug === chipCategory.slug;

          if (!chipCategory) return null;

          // get article count
          // const articleCount = 85; // todo - should use /articles?categories=(mappedCategory.slug)&take=0 to get total in category
          return (
            <Chip
              key={`chip-${chip}`}
              label={chipName}
              variant={selected ? 'filled' : 'outlined'}
              color="primary"
              onClick={() => {
                if (chipUrl) navigate(chipUrl);
              }}
            />
          );
        })}
      </ChipsList>
    </ChipsWrapper>
  );
};

export default SubCategoryChips;

const ChipsWrapper = styled.div`
  margin-top: -3px;
  margin-bottom: 4px;
`;
